import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './containers/Home';
import About from './containers/Pages/About';
import FinTechConsulting from './containers/Pages/FinTechConsulting';
import PaymentSolutions from './containers/Pages/PaymentSolutions';
import AMLManagedServices from './containers/Pages/AMLManagedServices';
import ThirdPartyRiskManagement from './containers/Pages/ThirdPartyRiskManagement';
import ComplianceSupport from './containers/Pages/ComplianceSupport';
import KYCVerification from './containers/Pages/KYCVerification';
import Industries from './containers/Pages/Industries';
import Resources from './containers/Pages/Resources';
import Contact from './containers/Pages/Contact';
import PrivacyPolicy from './containers/Pages/PrivacyPolicy';
import TermsAndConditions from './containers/Pages/TermsAndConditions';



function App() {
  return (
    <div className="App">
      <Router>


        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/fintech-consulting' element={<FinTechConsulting />} />
          <Route path='/payment-solutions' element={<PaymentSolutions />} />
          <Route path='/aml-managed' element={<AMLManagedServices />} />
          <Route path='/third-party-risk-management' element={<ThirdPartyRiskManagement />} />
          <Route path='/compliance-support' element={<ComplianceSupport />} />
          <Route path='/kyc-verification' element={<KYCVerification />} />
          <Route path='/industries' element={<Industries />} />
          <Route path='/resources' element={<Resources />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-conditions' element={<TermsAndConditions />} />



        </Routes>
      </Router>
    </div>
  );
}

export default App;
